import type { IntakeSpec, ArchitectureFacadeDetailDetails } from '@shared/types';
import type { Part, Joint, Feature, WallOpening } from '@shared/spec';

function getDetails(intake: IntakeSpec): ArchitectureFacadeDetailDetails {
  return intake.details as ArchitectureFacadeDetailDetails;
}

function scaleNumber(scaleRatio: string): number {
  // e.g., '1:20' -> 20
  return parseInt(scaleRatio.split(':')[1], 10);
}

export function parts(intake: IntakeSpec): Part[] {
  const d = getDetails(intake);
  const scale = scaleNumber(d.scaleRatio);

  // Real-world detail dimensions in mm
  const realLength = intake.core.size?.length ?? 1000; // 1m default
  const realWidth = intake.core.size?.width ?? 1000;   // 1m default
  const wallThickness = 3; // model material thickness, NOT scaled

  const modelWidth = realLength / scale;   // horizontal extent (wall width)
  const modelHeight = realWidth / scale;   // vertical extent (wall height)

  // Determine openings based on detailType
  const openings: WallOpening[] = [];

  if (d.detailType === 'window') {
    openings.push({
      kind: 'window',
      x: 0,
      z: 200 / scale,
      width: 800 / scale,
      height: 1200 / scale,
    });
  } else if (d.detailType === 'door') {
    openings.push({
      kind: 'door',
      x: 0,
      z: 200 / scale,
      width: 800 / scale,
      height: 1200 / scale,
    });
  } else if (d.detailType === 'curtain_wall') {
    openings.push({
      kind: 'window',
      x: 0,
      z: (100 / scale) / 2,
      width: modelWidth - 100 / scale,
      height: modelHeight - 100 / scale,
    });
  }
  // TODO: cornice and parapet are decorative features, not openings — no geometry stub in V1.

  return [
    {
      id: 'facade_wall',
      name: 'ファサード壁',
      kind: 'wall',
      materialId: 'mat-primary',
      width: modelWidth,
      height: modelHeight,
      thickness: wallThickness,
      position: [0, 0, 0],
      rotation: [0, 0, 0],
      tags: ['facade'],
      openings,
      paramRefs: [],
    },
  ];
}

export function joints(_intake: IntakeSpec): Joint[] {
  return [];
}

export function features(_intake: IntakeSpec): Feature[] {
  return [];
}
